export const threeColumnContentModifier = (node: HTMLDivElement) => {
  node.querySelectorAll('.threecolumn').forEach((threecolumn) => {
    if (
      (threecolumn.nextElementSibling &&
        threecolumn.nextElementSibling?.classList.contains('threecolumn')) ||
      (threecolumn.previousElementSibling &&
        threecolumn.previousElementSibling?.classList.contains('threecolumn'))
    ) {
      threecolumn.classList.add('threecolumn--half');
    }
  });
}